(function () {
  'use strict';
  angular.module('obex').
  factory('commonDialog', ['ngDialog',
    function (ngDialog) {
      return {
        confirmDialog: '<div class="ngdialog-buttons"> ' +
          '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">No</button>' +
          '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-primary" ng-click="confirm(1)">Yes</button>' +
          '</div>',
        openDialog: '<div class="ngdialog-buttons">' +
          '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Ok </button>' +
          '</div>',
      };
    },
  ]);
})();



// WEBPACK FOOTER //
// ./client/js/constants/commonDialog.js